<template>
  <div>
    <template v-if="item.filename && item.base64">
      <table-control type="download" @click.prevent="download_file()" />
    </template>
  </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    methods: {
      download_file() {
        const link = document.createElement('a');
        link.href = this.item.base64;
        link.target = '_blank';
        link.download = this.item.filename;

        link.click();
      }
    }
  };
</script>
